module.exports = __webpack_public_path__ + "img/0. login.ac828343.jpg";